import React, { useState } from "react";
import {
  decrypt,
  encrypt,
  encryptState,
  setEncodedCookie,
  setEncodedCookieOneYear,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import AuthBg from "./AuthBg";
import * as Yup from "yup";
import { useFormik } from "formik";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import ClipLoader from "react-spinners/ClipLoader";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { ToastContainer } from "react-toastify";
import {
  getCookie,
  setCookie,
  setCookieForOneYear,
} from "../../helpers/CookieComponent";

// Encrypted key for sessionStorage (same as in Register.js)
const REGISTRATION_KEY = encrypt("registrationData");

// Formik InitialValues
const initialValues = {
  email: "",
  password: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  email: Yup.string().trim().required("Email is required"),
  password: Yup.string().trim().required("Password is required"),
});

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const [isRemember, setIsRemember] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        email: values.email,
        password: values.password,
      };

      const response = await postData("user/login", param, apiHeader(false));
      console.log(response);

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        const userData = response.data.data;
        const emailVerify = userData?.emailVerify;
        const mobileNumberVerify = userData?.mobileNumberVerify;

        // Check if both email and mobile are verified
        if (emailVerify && mobileNumberVerify) {
          // Both verified - proceed with login
          toastsuccessmsg(response.data.message);
          if (isRemember) {
            setCookieForOneYear("token", encrypt(userData.token));
          } else {
            setCookie("token", encrypt(userData.token), {});
          }
          setCookie("userId", encrypt(userData._id), {});
          setTimeout(() => {
            setLoading(false);
            document.location.reload();
            resetForm();
          }, 1500);
        } else {
          // Not fully verified - redirect to Register step 2
          const registrationData = {
            currentStep: 2,
            isRegistered: true,
            fromLogin: true,
            formData: {
              fullName: userData?.fullName || "",
              email: values.email,
              mobileNumber: userData?.mobileNumber || "",
              fullPhoneNumber: "",
              password: "",
              confirmPassword: "",
              referCode: "",
              emailOtp: "",
              userId: userData?._id || "",
              mobileOtp: "",
              agreeTerms: false,
            },
            phoneValue: userData?.countryCode && userData?.mobileNumber
              ? `${userData.countryCode}${userData.mobileNumber}`
              : "",
            countryCode: userData?.countryCode || "91",
            otpSent: { email: false, mobile: false },
            otpVerified: {
              email: emailVerify || false,
              mobile: mobileNumberVerify || false
            },
          };

          // Save to sessionStorage with encrypted key and value
          const REGISTRATION_KEY = encrypt("registrationData");
          sessionStorage.setItem(REGISTRATION_KEY, encryptState(registrationData));

          toasterrormsg("Please complete verification to continue");
          setTimeout(() => {
            setLoading(false);
            navigate("/register");
          }, 1500);
        }
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  return (
    <>
      <ToastContainer />
      <div className="flex flex-col lg:flex-row lg:justify-end lg:min-h-[85vh] xl:min-h-screen h-max">
        {/* Background Section */}
        <div className="h-auto lg:h-screen z-[1] relative lg:fixed top-0 left-0 lg:w-[40%]">
          <AuthBg />
        </div>
        <div className="lg:w-[60%] py-[5%] px-[5%] md:px-[10%] bg-yellow">
          <div className="flex flex-col lg:flex-row w-full p-10">
            <div className="flex items-center justify-center flex-col lg:flex-row w-full">
              <div className="w-full lg:w-[500px]">
                <h1 className="mb-4 auth-title-y">Welcome to, GCC Law Help</h1>
                <p className="mb-[5%] auth-text-g">
                  New here?{" "}
                  <Link
                    to="/register"
                    className="auth-text-b"
                    onClick={() => sessionStorage.removeItem(REGISTRATION_KEY)}
                  >
                    {" "}
                    Register
                  </Link>
                </p>
                <form onSubmit={formik.handleSubmit}>
                  <div className="w-full flex flex-col gap-[2rem] mb-[7rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full auth-input-label mb-4 required"
                      >
                        Email
                      </label>
                      <input
                        className="w-full auth-input"
                        type="email"
                        placeholder="Enter email"
                        id="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.email}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full auth-input-label mb-4 required"
                      >
                        Password
                      </label>
                      <div className="w-full relative">
                        <input
                          className="w-full auth-input"
                          type={isPasswordShow ? "text" : "password"}
                          placeholder="Enter password"
                          id="password"
                          value={formik.values.password}
                          onChange={formik.handleChange}
                        />
                        {isPasswordShow == true ? (
                          <FaEyeSlash
                            onClick={() => setIsPasswordShow(false)}
                            className="absolute cursor-pointer top-[2rem] right-[2.5rem] auth-input-eye"
                          />
                        ) : (
                          <FaEye
                            onClick={() => setIsPasswordShow(true)}
                            className="absolute cursor-pointer top-[2rem] right-[2.5rem] auth-input-eye"
                          />
                        )}
                      </div>
                      {formik.touched.password && formik.errors.password && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.password}</div>
                        </div>
                      )}
                    </div>
                    <Link
                      to="/forgotpassword"
                      className="font-bold auth-text-g mb-8"
                    >
                      Forgot password?
                    </Link>
                    <div className="w-full lg:col-span-2">
                      <label
                        htmlFor="rememberMe"
                        className="flex items-start gap-5 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          id="rememberMe"
                          name=""
                          checked={isRemember == true}
                          onChange={(e) =>
                            setIsRemember(e.target.checked ? true : false)
                          }
                          className={`w-[2rem] h-[2rem] mt-[.35rem] appearance-none border-2 border-[#2c3451] rounded-full transition-all checked:bg-[#2c3451] checked:border-transparent relative flex items-center justify-center before:content-['✔'] before:text-white before:text-lg before:hidden checked:before:block cursor-pointer`}
                        />
                        <span className="font-bold auth-text-b">
                          Remember me
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="w-full justify-center lg:justify-start gap-5 flex">
                    <button
                      type="submit"
                      className="btn-auth"
                      disabled={loading}
                    >
                      {!loading && <>Login</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
